import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component'
import { PageNotFoundComponent } from './page-not-found/page-not-found.component'
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component'
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component'
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component'
import { SuperAdminLayoutComponent } from './super-admin-layout/super-admin-layout.component'
import { AdminLayoutComponent } from './admin-layout/admin-layout.component'
import { UserLayoutComponent } from './user-layout/user-layout.component'
import { AddBusinessComponent } from './add-business/add-business.component'
import { AddBusinessUsersComponent } from './add-business-users/add-business-users.component'
import { AddUserComponent } from './add-user/add-user.component'
import { AddPartyComponent } from './add-party/add-party.component'
import { SlipFormComponent } from './slip-form/slip-form.component'
import { EditSlipComponent } from './edit-slip/edit-slip.component'
import { EditInvoiceComponent } from './edit-invoice/edit-invoice.component'
import { InvoiceFormComponent } from './invoice-form/invoice-form.component'
import { UnpaidInvoiceFormComponent } from './unpaid-invoice-form/unpaid-invoice-form.component'
import { ItemMasterComponent } from './item-master/item-master.component'
import { SlipToInvoiceFormComponent } from './slip-to-invoice-form/slip-to-invoice-form.component'
import { RoleMasterComponent } from './role-master/role-master.component'
import { InvoicePrintComponent } from './invoice-print/invoice-print.component'
import { SlipPrintComponent } from './slip-print/slip-print.component'
import { PrintLayoutComponent } from './print-layout/print-layout.component'
import { AnonymousGuard } from './anonymous.guard';
import { SuperAdminGuard } from './super-admin.guard';
import { AdminGuard } from './admin.guard';
import { UserGuard } from './user.guard';
import { SlipPopupComponent } from './app.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { InvoicePopupComponent } from './app.component';
import { AdminProfileComponent } from './admin-sidenav/admin-sidenav.component';
import { UserProfileComponent } from './user-sidenav/user-sidenav.component';
import { AddRecordPopupComponent } from './edit-slip/edit-slip.component';
import { AddInvoiceRecordPopupComponent } from './edit-invoice/edit-invoice.component';
// const routes: Routes = [
//   { path: "", component:LoginComponent, pathMatch: 'full'},
//   { path: "login", component:LoginComponent},
//   { path: "super-admin-dashboard", component:SuperAdminDashboardComponent},
//   { path: "**", component:PageNotFoundComponent }
// ];
const routes: Routes = [
    { path: '', component: LoginComponent, pathMatch: 'full', canActivate: [AnonymousGuard]},
    //Super admin routes goes here
    {
        path: '',
        component: SuperAdminLayoutComponent,
        canActivate: [SuperAdminGuard],
        children: [
          { path: 'super-admin-dashboard', component: SuperAdminDashboardComponent, canActivate: [SuperAdminGuard]},
          { path: 'add-business', component: AddBusinessComponent, canActivate: [SuperAdminGuard]},
          { path: 'add-business-user', component: AddBusinessUsersComponent,canActivate: [SuperAdminGuard]}
        ]
    },

    // Admin routes goes here here
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AdminGuard],
        children: [
          { path: 'admin/dashboard', component: AdminDashboardComponent,canActivate: [AdminGuard] },
          { path: 'admin/add-user', component: AddUserComponent,canActivate: [AdminGuard] },
          { path: 'admin/add-party', component: AddPartyComponent,canActivate: [AdminGuard] },
          { path: 'admin/new-slip', component: SlipFormComponent,canActivate: [AdminGuard] },
          { path: 'admin/edit-slip', component: EditSlipComponent,canActivate: [AdminGuard] },
          { path: 'admin/edit-invoice', component: EditInvoiceComponent,canActivate: [AdminGuard] },
          { path: 'admin/new-invoice', component: InvoiceFormComponent,canActivate: [AdminGuard] },
          { path: 'admin/add-item', component: ItemMasterComponent,canActivate: [AdminGuard] },
          { path: 'admin/unpaid-invoice', component: UnpaidInvoiceFormComponent,canActivate: [AdminGuard] },
          { path: 'admin/slip-to-invoice', component: SlipToInvoiceFormComponent,canActivate: [AdminGuard] },
          { path: 'admin/add-role', component: RoleMasterComponent,canActivate: [AdminGuard] },
          { path: 'admin/preferences', component: PreferencesComponent,canActivate: [AdminGuard] },
          { path: 'admin/profile', component: AdminProfileComponent,canActivate: [AdminGuard] }
        ]
    },
    // User routes goes here here
    {
        path: '',
        component: UserLayoutComponent,
        canActivate: [UserGuard],
        children: [
          { path: 'user/dashboard', component: UserDashboardComponent, canActivate: [UserGuard] },
          { path: 'user/add-party', component: AddPartyComponent, canActivate: [UserGuard] },
          { path: 'user/new-slip', component: SlipFormComponent, canActivate: [UserGuard] },
          { path: 'admin/edit-slip', component: EditSlipComponent,canActivate: [UserGuard] },
          { path: 'admin/edit-invoice', component: EditInvoiceComponent,canActivate: [UserGuard] },
          { path: 'user/new-invoice', component: InvoiceFormComponent, canActivate: [UserGuard] },
          { path: 'user/add-item', component: ItemMasterComponent, canActivate: [UserGuard] },
          { path: 'user/unpaid-invoice', component: UnpaidInvoiceFormComponent, canActivate: [UserGuard] },
          { path: 'user/slip-to-invoice', component: SlipToInvoiceFormComponent, canActivate: [UserGuard] },
          { path: 'user/profile', component: UserProfileComponent,canActivate: [UserGuard] }
        ]
    },
    //Print routs goes here
    { path: 'print',
      outlet: 'print',
      component: PrintLayoutComponent,
      children: [
        { path: 'invoice/:invoiceIds', component: InvoicePrintComponent,canActivate: [AdminGuard] },
        { path: 'slip/:slipIds', component: SlipPrintComponent,canActivate: [AdminGuard] }
      ], canActivate: [AdminGuard]
    },

    //no layout routes
    { path: "record-popup", component:AddRecordPopupComponent, canActivate: [AnonymousGuard]},
    { path: "invoice-record-popup", component:AddInvoiceRecordPopupComponent, canActivate: [AnonymousGuard]},
    { path: "slip-popup", component:SlipPopupComponent, canActivate: [AnonymousGuard]},
    { path: "invoice-popup", component:InvoicePopupComponent, canActivate: [AnonymousGuard]},
    { path: 'login', component: LoginComponent, canActivate: [AnonymousGuard]},
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
